export class Router {
  constructor(private readonly onNavigate: (path: string, push: boolean) => void) {}
  start(): void {
    addEventListener('popstate', this.onPopState);
    document.addEventListener('click', this.onClick);
  }
  private readonly onPopState = (): void => this.onNavigate(location.pathname + location.hash, false);
  private readonly onClick = (event: MouseEvent): void => {
    const anchor = (event.target as Element)?.closest<HTMLAnchorElement>('a[data-route]');
    if (
      !anchor ||
      anchor.origin !== location.origin ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      anchor.target === '_blank' ||
      anchor.hasAttribute('download')
    )
      return;
    event.preventDefault();
    this.onNavigate(anchor.pathname + anchor.hash, true);
  };
  destroy(): void {
    removeEventListener('popstate', this.onPopState);
    document.removeEventListener('click', this.onClick);
  }
}
